import {
  ArrayStepperConfig,
  FormElementConfig,
  SectionConfig,
} from "./FormComponents";

export function isArrayStepperConfig<T extends string>(
  el: FormElementConfig<T>,
): el is ArrayStepperConfig<T> {
  return "type" in el && el.type === "arrayStepper";
}

export function isSectionConfig<T extends string>(
  el: FormElementConfig<T>,
): el is SectionConfig<T> {
  return (el as SectionConfig<T>).type === "section";
}
